import script from "./CommentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentItem.vue?vue&type=script&setup=true&lang=js"

import "./CommentItem.vue?vue&type=style&index=0&id=19e62bb8&lang=scss"

const __exports__ = script;

export default __exports__